import styled from 'styled-components';

export const ScoringTypeBlock = styled.div`
  margin-right: 4rem;
  display: flex;
  flex: 1;
  justify-content: space-between;
  align-items: center;
`;

export const DraftOrderBlock = styled.div`
  margin-bottom: 1rem;
  display: flex;
`;

export const DraftOrderNum = styled.div`
  width: 36px;
  height: 36px;
  background-color: grey;
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const OwnerName = styled.div`
  border: 1px solid lightgrey;
  width: 400px;
  padding: 0.5rem 1rem;
  display: flex;
  flex: 1;
  justify-content: space-between;
  align-items: center;
`;
